var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E65C6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1135 8.24999C16.0377 12.7533 12.0302 14.6667 10.6244 15.1975C10.4802 15.2523 10.3265 15.2779 10.1723 15.2729C10.0181 15.2679 9.86642 15.2323 9.72605 15.1683C8.34355 14.5383 4.16688 12.3333 4.22521 8.29665C4.22218 7.51215 4.47933 6.74879 4.95643 6.12603C5.43353 5.50327 6.10364 5.05627 6.86188 4.85499C7.37459 4.7167 7.91066 4.68782 8.43527 4.77023C8.95987 4.85264 9.46126 5.04449 9.90688 5.33332C9.98575 5.38501 10.078 5.41255 10.1723 5.41255C10.2666 5.41255 10.3588 5.38501 10.4377 5.33332C10.9238 5.02024 11.475 4.82228 12.0492 4.75455C12.6234 4.68682 13.2055 4.7511 13.751 4.94249C14.4341 5.18876 15.0259 5.63711 15.4479 6.22793C15.8699 6.81874 16.1021 7.52402 16.1135 8.24999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.3e0075fb24f5c11bf11c399e5098a36f.svg";
export { ForwardRef as ReactComponent };